const props = {
  /** the container has a closer span */
  closer: Boolean,
  /** the modal state, can be used as modelValue */
  state: Boolean,
  /** exits on the outer part of modal */
  outer: Boolean,
  /** exits on the modal itself */
  inner: Boolean,
};

export default props;
